import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './Button';
const list = ['Tomo 1 — Orígenes y Culturas', 'Tomo 2 — Conquista y Colonia', 'Tomo 3 — Independencia', 'Tomo 4 — Siglo XIX', 'Tomo 5 — Siglo XX', 'Tomo 6 — Procesos Contemporáneos', 'Tomo 7 — Fuentes Históricas', 'Tomo 8 — Actividades y Evaluaciones', 'Bono 1 — Banco de Evaluaciones y Rúbricas', 'Bono 2 — Glosario Completo de Términos', 'Bono 3 — Manual de Respuestas para Preguntas Difíciles', 'Bono 4 — Líneas del Tiempo Completas', 'Garantía de 7 días sin preguntas', 'Acceso inmediato'];
export function FinalCTA() {
  return <section className="bg-mist px-4 py-20" data-id="element-74" data-mp="vu8g5j31157x">
      <div className="mx-auto max-w-4xl text-center" data-id="element-75" data-mp="qvx4d2t68kn2">
        <h2 className="font-serif text-3xl font-bold leading-tight text-navy sm:text-5xl" data-id="element-76" data-mp="qw6sslykijqn">
          El próximo lunes puedes seguir improvisando...
          <br data-id="element-77" data-mp="zwmt5mk0lara" />
          <span className="text-gold-dark" data-id="element-78" data-mp="zx4rqpu5g12d">
            O resolver tu año entero de Historia en solo 5 MINUTOS desde hoy.
          </span>
        </h2>
        <p className="mx-auto my-9 max-w-2xl text-lg leading-relaxed text-ink" data-id="element-79" data-mp="2c6r6bv3c9qhs">
          Vos ya eres un buen docente. El Mega Pack te da el tiempo y las
          herramientas para que eso se note en cada clase.
        </p>
        <div className="rounded-3xl border border-slate-100 bg-white p-7 shadow-[0_10px_28px_rgba(16,42,67,.08)] sm:p-10" data-id="element-80" data-mp="2r1nqn6ofa4b8">
          <h3 className="border-b border-slate-100 pb-5 text-xl font-bold text-navy" data-id="element-81" data-mp="2v4ai36h6ln7w">
            Todo lo que incluye:
          </h3>
          <div className="my-8 grid gap-3 text-left md:grid-cols-2" data-id="element-82" data-mp="300soeas5ttmc">
            {list.map(item => <p className="flex gap-2 text-sm text-ink" key={item} data-id="element-83" data-mp="34vf0kg62fq7h">
                <Check size={17} className="shrink-0 text-green" data-id="element-84" data-mp="39r3rjv40rys6" />
                {item}
              </p>)}
          </div>
          <p className="mb-3 font-serif text-xl font-bold text-navy" data-id="element-85" data-mp="3epf44dlp8ne3">
            Mega Pack Historia 360
          </p>
          <p className="mb-6 text-sm text-slate-500" data-id="element-86" data-mp="1jod0qlp67e08">
            Resuelve tu año entero de Historia en solo 5 MINUTOS.
          </p>
          <Button href="#pricing" className="w-full sm:w-auto" data-id="element-87" data-mp="1eqbe5qsjcwk0">
            QUIERO MI MEGA PACK AHORA
          </Button>
          <p className="mt-5 text-xs text-slate-500" data-id="element-88" data-mp="1si83jn2tkscp">
            Garantía de 7 días · Pago seguro · Acceso inmediato · Pagas en tu
            moneda local
          </p>
        </div>
      </div>
    </section>;
}